// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper-slide[data-v-fced0622]{width:auto}.flip-list-move[data-v-fced0622]{transition:transform .3s}.fade-enter-active[data-v-fced0622],.fade-leave-active[data-v-fced0622]{transition:opacity .3s}.fade-enter[data-v-fced0622],.fade-leave-to[data-v-fced0622]{opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
